/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPaymentDevicePresentationOrdersRequest} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/get_payment_device_presentation_orders.pb'
import {GetPaymentDevicePresentationOrdersResponse} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/get_payment_device_presentation_orders.pb'


export const getPaymentDevicePresentationOrders = (request: GetPaymentDevicePresentationOrdersRequest, options?: CashRequestOptions) => post<GetPaymentDevicePresentationOrdersRequest, GetPaymentDevicePresentationOrdersResponse>("/2.0/cash/get-payment-device-presentation-orders", request, {...options, rejectOnError: true })